/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestRawBasic from '@/utils/requestRawBasic'
import { APICore } from '@/utils/servicesApi'


export function loginAgentStored(data) {
  return requestRaw({
    url: APICore() + '/sign-agent/login/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}

// const qs = require('qs')
export function loginMemberValidation(data) {
  return requestRawBasic({
    url: APICore() + '/zeus/login/validation',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function loginMemberStored(data) {
  return requestRawBasic({
    url: APICore() + '/zeus/login/stored',
    method: 'POST',
    data: data // untuk array data post
  })
}

// Validasi ulang kredensial admin tanpa membuat token baru.
// Endpoint ini memakai mekanisme LoginValidation(), bukan LoginStored().
export function validateAdminCredential(data) {
  return requestRawBasic({
    url: APICore() + '/zeus/login/validation',
    method: 'POST',
    data: data,
    silent: true
  })
}
export function getProfile() {
  return requestRaw({
    url: APICore() + '/zeus/account/profile',
    method: 'GET',
    // data: data // untuk array data post
  })
}


export function getBank() {
  return requestRaw({
    url: APICore() + '/zeus/account/bank',
    method: 'GET',
    // data: data // untuk array data post
  })
}


export function getBankList() {
  return requestRaw({
    url: APICore() + '/zeus/account/bank_list',
    method: 'GET',
    // data: data // untuk array data post
  })
}

export function logout() {
  return requestRaw({
    url: APICore() + '/zeus/account/logout',
    method: 'GET',
    // data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js